import { fetchStudentProfileImage } from "./api";

/**
 * Module-level avatar cache shared by all UserLink instances so a table full of
 * the same user (or many UserLinks) only fetches each avatar once. Resolves to an
 * absolute image URL or null (no image / forbidden / offline → initials fallback).
 */
const cache = new Map<string, string | null>();
const inflight = new Map<string, Promise<string | null>>();

export async function getCachedAvatar(idOrEmail: string): Promise<string | null> {
  if (cache.has(idOrEmail)) return cache.get(idOrEmail)!;
  let p = inflight.get(idOrEmail);
  if (!p) {
    p = fetchStudentProfileImage(idOrEmail)
      .then((url) => {
        cache.set(idOrEmail, url);
        inflight.delete(idOrEmail);
        return url;
      })
      .catch(() => {
        inflight.delete(idOrEmail);
        return null;
      });
    inflight.set(idOrEmail, p);
  }
  return p;
}

/** Synchronous peek for instant paint; undefined when not yet cached. */
export function peekAvatar(idOrEmail: string): string | null | undefined {
  return cache.get(idOrEmail);
}
